import Axios from "../../axios-default"

const namespaced = true;

const state = () => ({
  loading: false,
  saving: false,
  syncTime: null,
  syncPeriod: 1000 * 60 * 3,
  itemsPerPage: 20,
  icons: ['mdi-crown','mdi-tune','mdi-eye-outline'],
  currentControllerId: null,
  users: []
});

const getters = {
  users(state) {
    return state.users;
  },
  icons(state) {
    return state.icons;
  },
  userByEmail: (state) => (email) => {
    //if (typeof state.users === 'object') {
    return state.users.find(item => item.email == email)
  }
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading
  },
  setSaving(state, saving) {
    state.saving = saving
  },
  setSyncTime(state, syncTime) {
    state.syncTime = syncTime
  },
  setUsers(state, data) {
    state.users = data
  },
  reset(state, controllerId) {
    state.users = [];
    state.syncTime = null;
    state.loading = false;
    state.currentControllerId = controllerId;
  }
};

const actions = {  
  async getUsers ({commit, rootGetters, state}, {controllerId, forced}) {
    //reset jesli zmiana kontrolera
    if (controllerId != state.currentControllerId) {
      commit('reset', controllerId);
    }

    try {
      if (!state.loading && (controllerId != state.currentControllerId || forced || state.syncTime === null || new Date().getTime() - state.syncTime > state.syncPeriod)) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        if (controllerId) {
          formData.append('controllerId', controllerId);
        }
        formData.append('token', rootGetters.token);
        
        const res = await Axios.post('/api/sterownik/uprawnienia/lista?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else {
          commit('setLoading', false);
          commit('setUsers', res.data);
          commit('setSyncTime', new Date().getTime());
        }
        return res.data;
      } else {
        return { skip: true }
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async saveUser({commit, rootGetters, state}, data) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', data.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('email', data.email);
        formData.append('permission', data.permission);
        const res = await Axios.post('/api/sterownik/uprawnienia/edytuj?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setSyncTime', null);
        }
        commit('setSaving', false);
        return res.data;
      } else {
        return { skip: true }
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}

//https://markus.oberlehner.net/blog/make-your-vuex-state-flat-state-normalization-with-vuex/
